<template>
    <div class="py-4 container-fluid">
        <div class="mt-4 row">
            <div class="col-12">
                <div class="card">
                    <!-- Card header -->
                    <div class="card-header border-bottom">
                        <div class="row d-flex align-items-center">
                            <div class="col-6">
                                <h5 class="mb-0">Kapcsolat Hozzáadása</h5>
                            </div>
                            <div class="col-6 text-end d-flex gap-4 justify-content-end">
                                <material-button class="float-right btn btm-sm"
                                    @click="this.$router.push({ name: 'Contacts List' })" color="secondary">
                                    Vissza
                                </material-button>
                                <material-button @click.prevent="handleAdd">Hozzáadás</material-button>
                            </div>
                        </div> 
                    </div>
                    <!--Card body-->
                    <div class="card-body">
                        <div class="container my-6 px-0">
                            <div class="row g-0">
                                <div class="col-md-3">
                                    <div class="text-center mb-4 pe-1">
                                            <div v-if="previewImages.length > 0" class="text-center" style="cursor: pointer;">
                                                <div class="" @click="removeImage(0)">✖</div>
                                                <img :src="previewImages[0]" alt="Előnézet" class="img-thumbnail w-100" style="aspect-ratio: 1/1; object-fit: cover;" />
                                                <div class="bg-success text-white p-2 mt-1 rounded text-truncate w-100">
                                                    {{ fileNames[0] }}
                                                </div>
                                            </div>
                                            <div v-if="previewImages.length === 0" class="text-center d-flex flex-column align-items-center justify-content-center text-center" style="cursor: pointer;" @click="$refs.fileInput.click()">
                                                <div class="d-flex align-items-center justify-content-center w-100" style="aspect-ratio: 1/1;">
                                                    <img src="@/assets/img/img-placeholder.webp" alt="Kép helyőrző" class="w-100 h-100" style="object-fit: cover;" />
                                                </div>
                                                <p class="text-white bg-success w-100 text-center fw-bold mb-0">KÉP HOZZÁADÁS +</p>
                                            </div>
                                        </div>
                                    <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/jpeg, image/png, image/webp" class="d-none" />
                                </div>
            
                                <div class="col-md-8">
                                    <form>
                                        <div class="row g-0">
                                            <div class="col-12 border border-secondary rounded-end p-3">
                                                <div class="form-group d-flex align-items-center mb-1">
                                                    <label class="fw-bold me-2 mb-0 col-4">Név/Cégnév</label>
                                                    <div class="flex-grow-1">
                                                        <material-input id="name" v-model:value="contact.name" placeholder="Kötelező" name="name" variant="static" />
                                                        <validation-error :errors="apiValidationErrors.name" />
                                                    </div>
                                                </div>

                                                <div class="form-group d-flex align-items-center mb-1">
                                                    <label class="fw-bold me-2 mb-0 col-4">Személyazonosító okmány/Adószám</label>
                                                    <div class="flex-grow-1">
                                                        <material-input id="vat_number" v-model:value="contact.vat_number" placeholder="Opcionális" name="vat_number" variant="static" />
                                                        <validation-error :errors="apiValidationErrors.vat_number" />
                                                    </div>
                                                </div>

                                                <div class="form-group d-flex align-items-center">
                                                    <label class="fw-bold me-2 mb-0 col-4">Kapcsolati besorolás</label>
                                                    <div class="flex-grow-1">
                                                        <FormDropDown
                                                        v-model.number="contact.contact_types_id"
                                                        :possible-values="contacttypesList"
                                                        placeholder="Válassz a listából"
                                                        :searchable="true"
                                                        mode="single"
                                                        />
                                                    </div>
                                                </div>

                                                <div class="form-group d-flex align-items-center mb-1">
                                                    <label class="fw-bold me-2 mb-0 col-4">Kapcsolattartó</label>
                                                    <div class="flex-grow-1">
                                                        <material-input id="contact" v-model:value="contact.contact" placeholder="Kötelező" name="contact" variant="static" />
                                                        <validation-error :errors="apiValidationErrors.contact" />
                                                    </div>
                                                </div>

                                                <div class="form-group d-flex align-items-center mb-1">
                                                    <label class="fw-bold me-2 mb-0 col-4">Telefonszám</label>
                                                    <div class="flex-grow-1">
                                                        <material-input id="phone_number" v-model:value="contact.phone_number" placeholder="Kötelező" name="phone_number" variant="static" @input="formatPhoneNumber"/>
                                                        <validation-error :errors="apiValidationErrors.phone_number" />
                                                    </div>
                                                </div>

                                                <div class="form-group d-flex align-items-center mb-1">
                                                    <label class="fw-bold me-2 mb-0 col-4">E-mail cím</label>
                                                    <div class="flex-grow-1">
                                                        <material-input id="email" v-model:value="contact.email" placeholder="Kötelező" name="email" variant="static" @input="validateEmail"/>
                                                        <validation-error :errors="apiValidationErrors.email" />
                                                    </div>
                                                </div>

                                                <div class="form-group d-flex align-items-center mb-1">
                                                    <label class="fw-bold me-2 mb-0 col-4">Levelezési cím</label>
                                                    <div class="flex-grow-1">
                                                        <material-input id="address" v-model:value="contact.address" placeholder="Kötelező" name="address" variant="static" />
                                                        <validation-error :errors="apiValidationErrors.address" />
                                                    </div>
                                                </div>

                                                <div class="form-group d-flex align-items-center mb-1">
                                                    <label class="fw-bold me-2 mb-0 col-4">Bankszámlaszám</label>
                                                    <div class="flex-grow-1">
                                                        <material-input id="manager" v-model:value="contact.account_number" placeholder="Opcionális" name="manager" variant="static" @input="formatAccountNumber" />
                                                        <validation-error :errors="apiValidationErrors.account_number" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-4 g-0">
                                            <div class="col-12 border border-secondary rounded p-3">
                                                <div v-for="(data, index) in ownersdata" :key="index" class="mb-1">
                                                    <div class="form-group d-flex align-items-center mb-3">
                                                        <label class="fw-bold me-2 mb-0 col-4">{{ index + 1 }}. Tulajdonos</label>
                                                        <div class="flex-grow-1 me-2">
                                                            <material-input :id="`owner${index + 1}`"
                                                                v-model:value="contact['owner' + (index + 1)]"
                                                                :name="`owner${index + 1}`" variant="static"
                                                                placeholder="Opcionális"
                                                                @input="updateOwner($event.target.value, index)" />
                                                            <validation-error :errors="apiValidationErrors['owner' + (index + 1)]" />
                                                        </div>
                                                        <i v-if="index === 0 && ownersdata.length < 3"
                                                            class="fas fa-plus-circle text-success fs-4 cursor-pointer"
                                                            @click="addMore()"></i>
                                                        <i v-else-if="index != 0 && ownersdata.length === (index + 1)"
                                                            class="fas fa-minus-circle text-danger fs-4 cursor-pointer"
                                                            @click="remove(index)"></i>
                                                    </div>
                                                    <div class="form-group d-flex align-items-center mb-3">
                                                        <label class="fw-bold me-2 mb-0 col-4">Tulajdoni hányad</label>
                                                        <div class="flex-grow-1">
                                                            <material-input :id="`ownership${index + 1}`"
                                                                v-model:value="contact['ownership' + (index + 1)]"
                                                                :name="`ownership${index + 1}`" variant="static"
                                                                placeholder="Opcionális"
                                                                @input="updateOwnership($event.target.value, index)" />
                                                            <validation-error :errors="apiValidationErrors['ownership' + (index + 1)]" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormDropDown from "@/components/FormDropdown.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/formMixin.js";
import showSwal from "../../../mixins/showSwal";

export default {
    name: 'AddContacts',
    components: {
        MaterialButton,
        MaterialInput,
        ValidationError,
        FormDropDown,
    },
    mixins: [formMixin],
    setup() {
        return {
            color: '#33e8f5'
        }
    },
    data() {
        return {
            contact: {},
            previewImages: [],
            fileNames: [],
            ownersdata: [
                { owner1: "", ownership1: "" }
            ],
        }
    },
    computed: {
        getcontacttypesList() {
            return this.$store.getters["contacttypes/getContactTypesData"];
        },
        contacttypesList() {
            const data = this.getcontacttypesList ?? [];
            return data.map(item => ({
                value: item.id,
                label: item.name
            }));
        },
    },
    async mounted() {
        await this.$store.dispatch("contacttypes/getContactTypes");
    },
    methods: {
        formatPhoneNumber(e) {
            let value = e.target.value.replace(/\D/g, ""); 
            value = value.substring(0, 11);
            if (value.startsWith("36")) value = "+" + value;
            else if (value.startsWith("06")) value = "+36" + value.slice(2);
            else if (!value.startsWith("+36")) value = "+36" + value;
            if (value.length > 3) {
                value = value.replace(/^(\+36)(\d{1,2})(\d{3})(\d{0,4})$/, (_, p1, p2, p3, p4) =>
                    [p1, p2, p3, p4].filter(Boolean).join(" ")
                );
            }
            this.contact.phone_number = value.trim();
        },
        validateEmail(e) {
            const email = e.target.value;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            this.contact.email = email;
            if (!emailRegex.test(email)) {
            this.apiValidationErrors.email = ['Érvénytelen email formátum!'];
            } else {
            this.apiValidationErrors.email = [];
            }
        },
        formatAccountNumber(e) {
            let value = e.target.value.replace(/\D/g, "");
            value = value.substring(0, 24);
            value = value.replace(/(\d{8})(\d{0,8})?(\d{0,8})?/, (_, p1, p2, p3) =>
            [p1, p2, p3].filter(Boolean).join("-")
            );

            this.contact.account_number = value;
        },
        handleFileUpload(event) {
            if (!this.contact.files) {
                this.contact.files = [];
            }

            const file = event.target.files[0];

            if (file && file.type.startsWith("image/")) {
                this.previewImages = [];
                this.fileNames = [];
                this.contact.files = [];
                
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewImages.push(e.target.result);
                    this.fileNames.push(file.name);
                    this.contact.files.push(file);
                };
                reader.readAsDataURL(file);
            }
        },
        removeImage(index) {
            this.previewImages = [];
            this.fileNames = [];
            this.contact.files = [];
        },
        async handleAdd() {
            this.resetApiValidation();
            try {
                await this.$store.dispatch("contacts/addContact", this.contact);
                showSwal.methods.showSwal({
                    type: "success",
                    message: "Bérlő sikeresen hozzáadva!",
                    width: 500
                });
                this.$router.push({ name: "Contacts List" })
            } catch (error) {
                if (error.response.data.errors) {
                    this.setApiValidation(error.response.data.errors);
                }
                showSwal.methods.showSwal({
                    type: "error",
                    message: "Valami hiba történt!",
                    width: 500
                });

            }
        },
        addMore() {
            this.ownersdata.push({
                ownerName: "",
                ownership: "",
            });
        },
        remove(index) {
            this.ownersdata.splice(index, 1);
        },
        updateOwner: function(value, index) {
            this.contact['owner' + (index + 1)] = value;
            this.$emit('input', value);
        },
        updateOwnership: function(value, index) {
            this.contact['ownership' + (index + 1)] = value;
            this.$emit('input', value);
        }
    }
}
</script>